import React, {useEffect, useState} from "react";
import {useSelector, useDispatch, shallowEqual} from "react-redux";
import {format} from "date-fns";
import {getDaysInMonth} from "../utils/dateHelper";
import {RootState} from "services/rootReducer";
import styles from "./css/YearViewComp.module.css";

import { Button, Modal } from "react-bootstrap";
import {calRangeType, setModalOpen, setModalDate, setModalMission, selectCalendarRange, selectMissionColorMap, selectHeatmap, selectModal} from "services/View_Slice"

import CONSTANTS from "../../constants"
import styled from "styled-components";
import { buildQueryViewParamsCal } from "../utils/queryHelper";
import { createToastProperties, toastListProp, toastType } from "components/toast/Toast";
import { addToQueue } from "services/Toasts_Slice";
const StyledDiv = styled.div`
    background-color: ${props => props.color};
`;

const YearViewComp = (props: any) => {
    const months: any[] = [];

    const { calRangeValue } = useSelector(selectCalendarRange);
    const missionColorMap = useSelector(selectMissionColorMap);
    const heatmap = useSelector(selectHeatmap);
    const { modalOpen, modalDate, modalMission } = useSelector(selectModal);
    const mobile = useSelector((state: RootState) => state.View.mobile);
    const request = useSelector((state: RootState) => state.Query.request);
    const facetSelected = useSelector((state: RootState) => state.Facets.facetSelected);
    const freeTextSearch = useSelector((state: RootState) => state.Search.freeTextSearch);

    const [links, setLinks] = useState<any[] | null>(null);

    //modal states
    const [modalDocs, setModalDocs] = useState(0);

    const handleClose = () => {
        dispatch(setModalOpen(false));
        dispatch(setModalDate(''));
        dispatch(setModalMission(''));
        setLinks(null);
    };
    const handleShow = (date: string, mission: string) => {
        dispatch(setModalOpen(true));
        dispatch(setModalDate(date));
        dispatch(setModalMission(mission));
    };

    const usedContainer = mobile? styles.container_mobile: styles.container;

    const dispatch = useDispatch()

    // Handle modal data fetching — triggered by click handlers and URL restoration
    useEffect(() => {
        if (modalOpen && modalDate && modalMission && links === null) {
            const viewparams = buildQueryViewParamsCal(100, calRangeType.day, modalDate);

            var facets: string = '';
            var key; var value;
            if(facetSelected !== undefined){
                for(var elem of facetSelected){
                    key = elem.split('@')[1];
                    value = elem.split('@')[0];
                    facets += '&fq=' + key + ':' + value
                }
            }
            var strs = "";
            var queryUrl = "";
            if(freeTextSearch != ""){
                for(var elem of freeTextSearch.split(" ")){
                    strs += elem + "* "
                }
                queryUrl = CONSTANTS.ENDPOINT.REST_API + CONSTANTS.REST_DO_QUERY + "?" + viewparams.slice(0,-1) + facets + "&q=_text_:" + strs;
            }else{
                queryUrl = CONSTANTS.ENDPOINT.REST_API + CONSTANTS.REST_DO_QUERY + "?" + viewparams.slice(0,-1) + facets + "&q=*:*";
            }

            var data = fetchResults(queryUrl)

            var res: any = data.then(response => {
                res = response

                var docs;
                if(res['response'] !== undefined){
                    docs = res['response']['docs'];
                    const elements: any = [];
                    for(let elem of docs){
                        elements.push(IDs(elem['title'], elem))
                    }
                    setLinks(elements);
                    setModalDocs(res['response']['numFound']);
                }else{
                    setLinks([]);
                    setModalDocs(0);
                }
            }).catch(function(error){
                const toastProperties: toastListProp = createToastProperties(toastType.error, 'error occurred while retrieving data', error.message);
                dispatch(addToQueue(toastProperties));
                handleClose();
            })
        }
    }, [modalOpen, modalDate, modalMission, links, facetSelected, freeTextSearch])

    //ID functional component 
    const IDs = (id: string, elem: any) => {
        const item = elem;
        const mission: string = item[CONSTANTS.UI.TOP_CAT];
        const title: string =  item['title'];
        const doctype: string = item['documenttype_ss']
        var aColor: string = '#000000';
        if(missionColorMap !== undefined && missionColorMap[mission] !== undefined && missionColorMap[mission] !== undefined){
            aColor = missionColorMap[mission];
        }

        //render ID
        return(
            <a key={elem['id']} className={styles.link} href={elem['id']} target="_blank" rel="noopener noreferrer">
                <StyledDiv className={styles.styleDiv} color={aColor}/>
                <div className={styles.elem_title}>
                    {title}
                </div>
                <div className={styles.elem_prop}>
                    {doctype}
                </div>
            </a>
        )
    }

    function fetchResults(yUrl: string){
        return fetch(yUrl)
        .then(response => response.json())
        .then(function(response) {
            return response
        })
        .catch(function(error) {
            console.error(error);
        });    
    }
    
    //Days functional component (renders day button with heatmap color)
    const Days = (day: Date | undefined, month: number) => {
        var d;
        var disabled = false;
        const dString = format(day!, 'yyyy-MM-dd')
        var numOfDocs = 0;
        var missionNumbs = []
        var missions = []
        for(let elem in heatmap){
            if(elem.split('T')[0] === dString){
                //console.log(elem['file_modified_dt'].split('T')[0] + '\n' + dString)
                for(let inner in heatmap[elem]){
                    missions.push(inner)
                    missionNumbs.push(heatmap[elem][inner])
                }
            }
        }
        if(day !== undefined){
            d = day.getDate();
        }
        if(day?.getMonth() !== month){
            disabled = true;            //disable days that are not in the month
        }

        for(let elem of missionNumbs)
            numOfDocs += parseInt(elem)

        //heatmap
        var useButton;
        if(numOfDocs > 0 && numOfDocs < 5){
            useButton = styles.button_full3;
        }else if(numOfDocs >= 5 && numOfDocs <= 10){
            useButton = styles.button_full2;
        }else if(numOfDocs > 10){
            useButton = styles.button_full1;
        }

        //render day
        return(
            <div key={dString}>
                {numOfDocs > 0 && !disabled ? 
                <Button className={useButton} disabled={disabled}
                onClick={() => {
                    setLinks(null);
                    handleShow(dString, 'mixed');
                }}>
                    {d}
                </Button>
                : 
                <Button className={styles.button} disabled={disabled}
                onClick={() => {
                    // alert(day);
                }}>
                    {d}
                </Button>
                }
            </div>  
        );
    }

    //MonthContainer functional component (renders month)
    const month_names = ["January", "February", "March","April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const MonthContainer = (month: number) => { 
        const dates: Date[] = getDaysInMonth(month, parseInt(calRangeValue));
        const d: any = [];
        const l: any = [];
        const mar: any = [];
        const mer: any = [];
        const g: any = [];
        const v: any = [];
        const s: any = [];

        //push days for each week day
        dates.forEach(element => {
            switch(element.getDay()){
                case 0: d.push(Days(element, month)); break;
                case 1: l.push(Days(element, month)); break;
                case 2: mar.push(Days(element, month)); break;
                case 3: mer.push(Days(element, month)); break;
                case 4: g.push(Days(element, month)); break;
                case 5: v.push(Days(element, month)); break;
                case 6: s.push(Days(element, month)); break;
            }
        });

        return(
            <div key={month} className={styles.month_container}>
                <div className={styles.month_title}>{month_names[month]}</div>
                <div className={styles.days_container}>
                    <div className={styles.week_container}>
                        M
                        {l}
                    </div>
                    <div className={styles.week_container}>
                        T
                        {mar}
                    </div>
                    <div className={styles.week_container}>
                        W
                        {mer}
                    </div>
                    <div className={styles.week_container}>
                        T
                        {g}
                    </div>
                    <div className={styles.week_container}>
                        F
                        {v}
                    </div>
                    <div className={styles.week_container}>
                        S
                        {s}
                    </div>
                    <div className={styles.week_container}>
                        S
                        {d}
                    </div>
                </div>
            </div>
        );
    }

    //push month components in months variable
    for(var i=0; i < 12; i++){
        months.push(MonthContainer(i))
    }

    //YearView render
    return(
        <div>
            <div className={usedContainer}>
                <Modal size="lg" centered={true} animation={false} className={styles.modal} show={modalOpen} onHide={handleClose}>
                    <Modal.Header closeButton>
                    <Modal.Title>{links === null ? 'Loading documents...' : `Documents Found: ${modalDocs}`}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {links === null ? (
                            <div style={{ textAlign: 'center', padding: '2rem' }}>
                                Loading documents...
                            </div>
                        ) : (
                            links
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="outline" onClick={handleClose}>
                        Close
                    </Button>
                    </Modal.Footer>
                </Modal>
                {months}
            </div>
        </div>
    );
}

export default YearViewComp;